module.exports = __webpack_public_path__ + "static/media/aragon97.d841f47b.jpg";